module.exports = __webpack_public_path__ + "static/jelly-development-d13bca3f0f154661d8ebae0d3bbeebe8.jpg";